// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueHead from 'vue-head';
import VueJsonp from 'vue-jsonp';
import VueCookie from 'vue-cookie';
import axios from 'axios';
import Meta from 'vue-meta';
import * as ModalDialogs from 'vue-modal-dialogs';
import 'es6-promise/auto';
import 'babel-polyfill';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import Vuelidate from 'vuelidate';

import '@arena/nav-lib/src/gnb';
import '@arena/nav-lib/src/footer';

import notificationAPI from './plugins/NotificationAPI';
import App from './App';
import router from './router';
import store from './store';
import i18n from './plugins/i18n';
import pluginHelper from './plugins/api-helper';
import dialogHelper from './plugins/dialog-helper';

axios.defaults.xsrfHeaderName = 'xsrf_default_overwritten';

Raven.config('https://948e5fdd713f424283f22a3ef0b58908@sentry.d.nexon.io/14', {
	release: VERSION,
	environment: process.env.NODE_ENV,
})
	.addPlugin(RavenVue, Vue)
	.install();

Vue.config.productionTip = false;

Vue.use(notificationAPI);
Vue.use(VueHead);
Vue.use(VueJsonp);
Vue.use(VueCookie);
Vue.use(Meta);
Vue.use(ModalDialogs);
Vue.use(Vuelidate);

Vue.use(pluginHelper);
Vue.use(dialogHelper);

Vue.prototype.$http = axios.create({
	withCredentials: true,
});

Vue.mixin({
	data() {
		return { region: environment.region };
	},
});
/* eslint-disable no-new */
window.App = new Vue({
	el: '#app',
	i18n,
	router,
	store,
	silentTranslationWarn: true,
	template: '<App/>',
	components: {
		App,
	},
	data() {
		return {
			getData: {},
		};
	},
	methods: {
		setCookie() {
			const // returnURL = this.$route.query.return_url,
			prodId = this.$route.query.prod_id;

			// if (returnURL) {
			// 	this.$cookie.set('ReturnURL', returnURL, {
			// 		expires: '10m',
			// 	});
			// }
			if (prodId) {
				this.$cookie.set('ProdId', prodId);
				this.$store.commit('setProductId', prodId);
			}
		},
		addScript(id, url) {
			return new Promise((resolve, reject) => {
				const g = document.createElement('script'),
					s = document.getElementsByTagName('script')[0];
				if (document.getElementById(id)) return;
				g.id = id;
				g.src = url;
				g.onload = resolve;
				g.onerror = reject;
				g.defer = true;
				s.parentNode.insertBefore(g, s);
			});
		},
	},
	beforeCreate() {
		this.$store.dispatch('retrieveConfiguration');
	},
	mounted() {
		this.setCookie();
	},
});



// WEBPACK FOOTER //
// ./src/main.js